import Cookies from 'js-cookie'

const TokenKey = 'token';
const TOKEN_EXPIRE_DAYS = 7;

function tokenCookieSecurityOptions() {
    return {
        sameSite: 'Lax',
        secure: window.location.protocol === 'https:'
    };
}

export function getToken() {
    return Cookies.get(TokenKey);
}

export function setToken(token) {
    if (!token) {
        return;
    }
    return Cookies.set(TokenKey, token, {
        expires: TOKEN_EXPIRE_DAYS,
        ...tokenCookieSecurityOptions()
    });
}

export function refreshTokenCookie(expectedToken) {
    const currentToken = getToken();
    if (expectedToken && currentToken === expectedToken) {
        return setToken(currentToken);
    }
}

export function removeToken(expectedToken) {
    const currentToken = getToken();
    if (!expectedToken || currentToken === expectedToken) {
        return Cookies.remove(TokenKey, tokenCookieSecurityOptions());
    }
}
